"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SMS_STATUS = exports.NUMBER_CHECK_LIST = exports.SMS_MEMBER_CHECK_LIST = exports.DATE_CHECK_LIST = exports.SMS_TYPE_CHECK_SUBSTITUTE = exports.SMS_TYPE_CHECK_NORMAL = exports.SMS_TYPE_CHECK_LIST = void 0;
exports.SMS_TYPE_CHECK_LIST = [
    { id: 'normal', title: 'sendSMS.normal', checked: true },
    { id: 'substitute', title: 'sendSMS.substitute', checked: false },
];
exports.SMS_TYPE_CHECK_NORMAL = [
    { id: 'normal', title: 'sendSMS.normal', checked: true },
];
exports.SMS_TYPE_CHECK_SUBSTITUTE = [
    { id: 'substitute', title: 'sendSMS.substitute', checked: true },
];
exports.DATE_CHECK_LIST = [
    { id: 'now', title: 'sendSMS.now', checked: true },
    { id: 'reservation', title: 'sendSMS.reservation', checked: false },
];
exports.SMS_MEMBER_CHECK_LIST = [
    { id: 'everyStudent', title: 'sendSMS.everyStudent', checked: true },
    { id: 'oneByOne', title: 'sendSMS.oneByOne', checked: false },
    { id: 'excelUpload', title: 'sendSMS.excelUpload', checked: false },
];
exports.NUMBER_CHECK_LIST = [
    { id: 'fix', title: 'sendSMS.fix', checked: true },
    { id: 'direct', title: 'sendSMS.direct', checked: false },
];
exports.SMS_STATUS = {
    CREATED: 'created',
    SENT: 'sent',
    FAILED: 'failed',
};
// export const SMS_STATUS = [
// 	{ id: 'create', title: 'sendSMS.create' },
// 	{ id: 'send', title: 'sendSMS.send' },
// 	{ id: 'failed', title: 'sendSMS.failed' },
// ];
